import { createContext, useEffect, useState } from "react";
import { getCurrentLang, toggleLangAndGetNext } from "../utils/lang";
import DateTime from "../utils/DateTime";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getCurrentLang());
  const handleToggleLang = () => {
    const nextLang = toggleLangAndGetNext();
    setLang(nextLang);
    DateTime.SetLang(nextLang);
  };
  useEffect(() => {
    const currentLang = getCurrentLang();
    setLang(currentLang);
    document.documentElement.lang = currentLang;
    document.documentElement.dir = currentLang === "ar" ? "rtl" : "ltr";
  }, []);
  // Update dir/lang when state changes
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLang: handleToggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
